import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, Table, TableHead, TableBody, TableRow, TableCell,
  TableContainer, Button, Chip, Switch, IconButton, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, Tabs, Tab, FormControl, InputLabel,
  Select, MenuItem, Checkbox, FormControlLabel, Alert, Divider } from '@mui/material';
import { Delete, PersonAdd, Tune, SwapHoriz, Groups, LockReset } from '@mui/icons-material';
import { reviewersAPI, formsAPI, facilitatorAPI, emailTemplatesAPI } from '../../services/api';
import { useSnackbar } from '../../utils/notify';
import dayjs from 'dayjs';

export default function ReviewerManagement() {
  var sn = useSnackbar(); var notify = sn.enqueueSnackbar;
  var ts = useState('reviewer'); var tab = ts[0]; var setTab = ts[1];
  var ps = useState([]); var people = ps[0]; var setPeople = ps[1];
  var is = useState(false); var inviteOpen = is[0]; var setInviteOpen = is[1];
  var iv = useState({email:'', name:'', custom_message:'', role:'reviewer',
    template_id:'', expiry_days:7});
  var invite = iv[0]; var setInvite = iv[1];
  var tp = useState([]); var templates = tp[0]; var setTemplates = tp[1];
  var rp = useState(null); var resetInfo = rp[0]; var setResetInfo = rp[1];
  var fs = useState([]); var forms = fs[0]; var setForms = fs[1];
  var acs = useState(null); var accessFor = acs[0]; var setAccessFor = acs[1];
  var acd = useState({form_ids:[], field_ids:[], can_see_identity:false, edit_form_ids:[]});
  var access = acd[0]; var setAccess = acd[1];
  var sch = useState({}); var schemas = sch[0]; var setSchemas = sch[1];
  var fr = useState(null); var facilFor = fr[0]; var setFacilFor = fr[1];
  var ff = useState(''); var facilForm = ff[0]; var setFacilForm = ff[1];
  var fx = useState([]); var facilLinks = fx[0]; var setFacilLinks = fx[1];
  var fv = useState([]); var allReviewers = fv[0]; var setAllReviewers = fv[1];

  function load() {
    reviewersAPI.list(tab)
      .then(function(r) { setPeople(r.data.data || []); })
      .catch(function(e) { console.error(e); });
  }
  useEffect(load, [tab]);

  useEffect(function() {
    formsAPI.list().then(function(r) { setForms(r.data.data || []); }).catch(function(){});
    emailTemplatesAPI.list().then(function(r) { setTemplates(r.data.data || []); }).catch(function(){});
  }, []);

  function blankInvite() {
    return {email:'', name:'', custom_message:'', role:tab, template_id:'', expiry_days:7};
  }

  // Shown next to the expiry field so the admin sees the actual date.
  function expiryDate(days) {
    var d = new Date();
    d.setDate(d.getDate() + (parseInt(days, 10) || 7));
    return dayjs(d).format('D MMM YYYY');
  }

  function handleInvite() {
    reviewersAPI.invite(Object.assign({}, invite, {
      role: tab,
      expiry_days: parseInt(invite.expiry_days, 10) || 7,
    })).then(function() {
      notify('Invitation sent \u2014 the link expires ' + expiryDate(invite.expiry_days), {variant:'success'});
      setInviteOpen(false);
      setInvite(blankInvite());
      load();
    }).catch(function(err) {
      notify((err.response && err.response.data && err.response.data.error) || 'Failed', {variant:'error'});
    });
  }

  function handleToggle(id) { reviewersAPI.toggle(id).then(load); }

  // The link is shown to the admin as well as emailed, because a locked-out
  // person needs it even when SMTP is off.
  function resetPassword(person) {
    if (!window.confirm('Send ' + person.name + ' a password reset link? Their current password keeps working until they use it.')) return;
    reviewersAPI.resetPassword(person.id).then(function(r) {
      setResetInfo(r.data.data);
    }).catch(function(e) {
      notify((e.response && e.response.data && e.response.data.error) || 'Could not create a reset link', {variant:'error'});
    });
  }

  // ── Which reviewers a facilitator follows up with ──────
  function openFacil(person) {
    Promise.all([
      facilitatorAPI.listReviewers(person.id),
      reviewersAPI.list('reviewer'),
    ]).then(function(res) {
      setFacilLinks(res[0].data.data || []);
      setAllReviewers(res[1].data.data || []);
      setFacilForm(forms.length > 0 ? forms[0].id : '');
      setFacilFor(person);
    });
  }

  function toggleFacilReviewer(reviewerId) {
    var on = facilLinks.some(function(l) {
      return l.reviewer_id === reviewerId && l.form_id === facilForm;
    });
    if (on) {
      setFacilLinks(facilLinks.filter(function(l) {
        return !(l.reviewer_id === reviewerId && l.form_id === facilForm);
      }));
    } else {
      setFacilLinks(facilLinks.concat([{reviewer_id: reviewerId, form_id: facilForm}]));
    }
  }

  function saveFacil() {
    var ids = facilLinks.filter(function(l) { return l.form_id === facilForm; })
      .map(function(l) { return l.reviewer_id; });
    facilitatorAPI.setReviewers(facilFor.id, {form_id: facilForm, reviewer_ids: ids})
      .then(function() {
        notify('Reviewers updated', {variant:'success'});
        setFacilFor(null);
      })
      .catch(function(e) {
        notify((e.response && e.response.data && e.response.data.error) || 'Failed', {variant:'error'});
      });
  }

  // Move someone between the two roles. The backend refuses without `force`
  // when a reviewer still has assignments, and tells us how many.
  function switchRole(person) {
    var target = tab === 'reviewer' ? 'viewer' : 'reviewer';
    reviewersAPI.setRole(person.id, {role: target}).then(function() {
      notify(person.name + ' is now a ' + target, {variant:'success'});
      load();
    }).catch(function(e) {
      var msg = (e.response && e.response.data && e.response.data.error) || 'Could not change role';
      if (e.response && e.response.status === 409) {
        if (window.confirm(msg + '\n\nChange the role anyway?')) {
          reviewersAPI.setRole(person.id, {role: target, force: true}).then(function() {
            notify(person.name + ' is now a ' + target, {variant:'success'});
            load();
          }).catch(function() { notify('Could not change role', {variant:'error'}); });
        }
        return;
      }
      notify(msg, {variant:'error'});
    });
  }

  function handleDelete(id, name) {
    var what = tab === 'viewer'
      ? 'Delete viewer "' + name + '"? Their dashboard and form access goes with them.'
      : tab === 'facilitator'
        ? 'Delete facilitator "' + name + '"? Any reviews they carried out are deleted too, and the reviewers they followed up with become unassigned.'
        : 'Delete reviewer "' + name + '"? Their assignments and any reviews they submitted are deleted permanently.';
    if (!window.confirm(what + '\n\nThis cannot be undone.')) return;
    reviewersAPI.delete(id).then(function(r) {
      notify((r.data && r.data.message) || 'Deleted', {variant:'info'});
      load();
    }).catch(function(err) {
      notify((err.response && err.response.data && err.response.data.error)
        || 'Could not delete this account', {variant:'error'});
    });
  }

  // ── Viewer access ──────────────────────────────────────
  function openAccess(person) {
    reviewersAPI.getAccess(person.id).then(function(r) {
      var a = r.data.data || {};
      setAccess({
        form_ids: a.form_ids || [],
        field_ids: a.field_ids || [],
        can_see_identity: !!a.can_see_identity,
        edit_form_ids: a.edit_form_ids || [],
      });
      setAccessFor(person);
      (a.form_ids || []).forEach(loadSchema);
    });
  }

  function loadSchema(formId) {
    if (schemas[formId]) return;
    formsAPI.get(formId).then(function(r) {
      var s = r.data.data.schema;
      var parsed = typeof s === 'string' ? JSON.parse(s) : s;
      if (typeof parsed === 'string') { try { parsed = JSON.parse(parsed); } catch (e) { parsed = {}; } }
      setSchemas(function(prev) {
        var next = Object.assign({}, prev); next[formId] = parsed; return next;
      });
    }).catch(function(){});
  }

  function toggleForm(formId) {
    var on = access.form_ids.indexOf(formId) >= 0;
    var ids = on
      ? access.form_ids.filter(function(f){ return f !== formId; })
      : access.form_ids.concat([formId]);
    var updates = {form_ids: ids};
    // If removing a form from view access, also remove from edit access
    if (on) {
      updates.edit_form_ids = (access.edit_form_ids || []).filter(function(f){ return f !== formId; });
    }
    setAccess(Object.assign({}, access, updates));
    if (!on) loadSchema(formId);
  }

  function toggleField(fieldId) {
    var on = access.field_ids.indexOf(fieldId) >= 0;
    setAccess(Object.assign({}, access, {
      field_ids: on
        ? access.field_ids.filter(function(f){ return f !== fieldId; })
        : access.field_ids.concat([fieldId]),
    }));
  }

  function saveAccess() {
    reviewersAPI.setAccess(accessFor.id, access).then(function() {
      notify('Access updated', {variant:'success'});
      setAccessFor(null);
    }).catch(function(e) {
      notify((e.response && e.response.data && e.response.data.error) || 'Failed', {variant:'error'});
    });
  }

  var E = React.createElement;
  var isViewerTab = tab === 'viewer';
  var isFacilTab = tab === 'facilitator';

  return E(Box, null,
    E(Box, {sx:{display:'flex', justifyContent:'space-between', alignItems:'center', mb:1}},
      E(Typography, {variant:'h4'}, 'Access control'),
      E(Button, {variant:'contained', startIcon:E(PersonAdd),
        onClick:function(){ setInvite(blankInvite()); setInviteOpen(true); }},
        isViewerTab ? 'Invite viewer' : isFacilTab ? 'Invite facilitator' : 'Invite reviewer')),

    E(Tabs, {value:tab, onChange:function(_, v){ setTab(v); },
      sx:{mb:2, borderBottom:1, borderColor:'divider'}},
      E(Tab, {value:'reviewer', label:'Reviewers'}),
      E(Tab, {value:'facilitator', label:'Facilitators'}),
      E(Tab, {value:'viewer', label:'Viewers'})),

    isViewerTab ? E(Alert, {severity:'info', sx:{mb:2}},
      'Viewers can read applications and dashboards. They cannot score, assign, decide or change anything. Use Access to choose which forms and questions each one sees.') : null,

    isFacilTab ? E(Alert, {severity:'info', sx:{mb:2}},
      'Facilitators follow up on review progress for a group of reviewers \u2014 who is assigned what and how far along it is, never scores or comments. They can also be given applications to review themselves, so they appear in the assignment lists alongside reviewers. A reviewer can have only one facilitator per form.') : null,

    E(Card, null,
      E(TableContainer, null,
        E(Table, {size:'small'},
          E(TableHead, null,
            E(TableRow, null,
              E(TableCell, null, 'Name'),
              E(TableCell, null, 'Email'),
              E(TableCell, null, 'Status'),
              E(TableCell, null, 'Active'),
              E(TableCell, null, 'Last login'),
              E(TableCell, {align:'right'}, 'Actions'))),
          E(TableBody, null,
            people.map(function(p) {
              return E(TableRow, {key:p.id, hover:true},
                E(TableCell, null, p.name),
                E(TableCell, null, p.email),
                E(TableCell, null, E(Chip, {label:p.invite_accepted ? 'Accepted' : 'Pending',
                  size:'small', color:p.invite_accepted ? 'success' : 'warning'})),
                E(TableCell, null, E(Switch, {checked:p.is_active, size:'small',
                  onChange:function(){ handleToggle(p.id); }})),
                E(TableCell, null, p.last_login ? dayjs(p.last_login).format('MMM D HH:mm') : '\u2014'),
                E(TableCell, {align:'right'},
                  isViewerTab
                    ? E(Button, {size:'small', startIcon:E(Tune),
                        onClick:function(){ openAccess(p); }}, 'Access')
                    : null,
                  isFacilTab
                    ? E(Button, {size:'small', startIcon:E(Groups),
                        onClick:function(){ openFacil(p); }}, 'Reviewers')
                    : null,
                  !isFacilTab
                    ? E(Button, {size:'small', startIcon:E(SwapHoriz),
                        onClick:function(){ switchRole(p); }},
                        isViewerTab ? 'Make reviewer' : 'Make viewer')
                    : null,
                  E(Button, {size:'small', startIcon:E(LockReset),
                    disabled:!p.invite_accepted,
                    onClick:function(){ resetPassword(p); }}, 'Reset password'),
                  E(IconButton, {size:'small', color:'error',
                    onClick:function(){ handleDelete(p.id, p.name); }},
                    E(Delete, {fontSize:'small'}))));
            }),
            people.length === 0
              ? E(TableRow, null, E(TableCell, {colSpan:6, align:'center',
                  sx:{py:4, color:'text.secondary'}},
                  isViewerTab ? 'No viewers yet.'
                    : isFacilTab ? 'No facilitators yet.'
                    : 'No reviewers yet. Invite someone to get started.'))
              : null)))),

    // Facilitator -> reviewers dialog
    facilFor ? E(Dialog, {open:true, onClose:function(){ setFacilFor(null); },
      maxWidth:'sm', fullWidth:true},
      E(DialogTitle, null, 'Reviewers followed up by ' + facilFor.name),
      E(DialogContent, {dividers:true},
        E(FormControl, {fullWidth:true, size:'small', sx:{mb:2}},
          E(InputLabel, null, 'Form'),
          E(Select, {value:facilForm, label:'Form',
            onChange:function(e){ setFacilForm(e.target.value); }},
            forms.map(function(f) { return E(MenuItem, {key:f.id, value:f.id}, f.title); }))),
        E(Typography, {variant:'caption', color:'text.secondary', sx:{display:'block', mb:1.5}},
          'A reviewer can have only one facilitator on a given form. If someone is already taken, saving will say so rather than moving them.'),
        allReviewers.map(function(rv) {
          var checked = facilLinks.some(function(l) {
            return l.reviewer_id === rv.id && l.form_id === facilForm;
          });
          return E(FormControlLabel, {key:rv.id, sx:{display:'block'},
            control:E(Checkbox, {size:'small', checked:checked,
              onChange:function(){ toggleFacilReviewer(rv.id); }}),
            label:E(Typography, {variant:'body2'}, rv.name + '  (' + rv.email + ')')});
        }),
        allReviewers.length === 0
          ? E(Alert, {severity:'info'}, 'No reviewers exist yet.') : null),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setFacilFor(null); }}, 'Cancel'),
        E(Button, {variant:'contained', disabled:!facilForm, onClick:saveFacil}, 'Save'))) : null,

    // Invite dialog
    E(Dialog, {open:inviteOpen, onClose:function(){ setInviteOpen(false); }, maxWidth:'sm', fullWidth:true},
      E(DialogTitle, null, isViewerTab ? 'Invite viewer' : 'Invite reviewer'),
      E(DialogContent, {sx:{pt:'16px !important'}},
        E(TextField, {fullWidth:true, label:'Name', value:invite.name, sx:{mb:2},
          onChange:function(e){ setInvite(Object.assign({}, invite, {name:e.target.value})); }}),
        E(TextField, {fullWidth:true, label:'Email', type:'email', value:invite.email, sx:{mb:2},
          onChange:function(e){ setInvite(Object.assign({}, invite, {email:e.target.value})); }}),
        E(TextField, {fullWidth:true, label:'Custom message (optional)', multiline:true, rows:3,
          value:invite.custom_message, sx:{mb:2},
          onChange:function(e){ setInvite(Object.assign({}, invite, {custom_message:e.target.value})); }}),

        E(FormControl, {fullWidth:true, size:'small', sx:{mb:2}},
          E(InputLabel, null, 'Email template'),
          E(Select, {value:invite.template_id, label:'Email template',
            onChange:function(e){ setInvite(Object.assign({}, invite, {template_id:e.target.value})); }},
            E(MenuItem, {value:''}, E('em', null, 'Default invitation template')),
            templates.map(function(t) {
              return E(MenuItem, {key:t.id, value:t.id},
                t.name + (t.template_type ? '  \u2014 ' + t.template_type : ''));
            }))),

        E(TextField, {fullWidth:true, size:'small', type:'number', label:'Link valid for (days)',
          value:invite.expiry_days, inputProps:{min:1, max:90},
          helperText:'Expires ' + expiryDate(invite.expiry_days),
          onChange:function(e){ setInvite(Object.assign({}, invite, {expiry_days:e.target.value})); }}),
        isViewerTab ? E(Alert, {severity:'info', sx:{mt:2}},
          'A new viewer sees nothing until you set their access after they accept.') : null),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setInviteOpen(false); }}, 'Cancel'),
        E(Button, {variant:'contained', onClick:handleInvite,
          disabled:!invite.name || !invite.email}, 'Send invitation'))),

    // Access dialog
    accessFor ? E(Dialog, {open:true, onClose:function(){ setAccessFor(null); },
      maxWidth:'md', fullWidth:true},
      E(DialogTitle, null, 'What ' + accessFor.name + ' can see'),
      E(DialogContent, {dividers:true},
        E(FormControlLabel, {sx:{mb:2},
          control:E(Switch, {checked:access.can_see_identity,
            onChange:function(e){ setAccess(Object.assign({}, access, {can_see_identity:e.target.checked})); }}),
          label:E(Box, null,
            E(Typography, {variant:'body2', fontWeight:600}, 'Show applicant names and emails'),
            E(Typography, {variant:'caption', color:'text.secondary'},
              access.can_see_identity
                ? 'Applications are identified by name'
                : 'Applications appear as reference numbers only'))}),

        E(Divider, {sx:{mb:2}}),

        E(Typography, {variant:'subtitle2', sx:{mb:1}}, 'Forms'),
        forms.map(function(f) {
          return E(FormControlLabel, {key:f.id, sx:{display:'block'},
            control:E(Checkbox, {size:'small', checked:access.form_ids.indexOf(f.id) >= 0,
              onChange:function(){ toggleForm(f.id); }}),
            label:E(Typography, {variant:'body2'}, f.title)});
        }),
        forms.length === 0 ? E(Typography, {variant:'body2', color:'text.secondary'}, 'No forms exist yet.') : null,

        E(Divider, {sx:{my:2}}),

        E(Typography, {variant:'subtitle2', sx:{mb:0.5}}, 'Editable forms'),
        E(Typography, {variant:'caption', color:'text.secondary', sx:{display:'block', mb:1}},
          'Choose which of the forms above this viewer can also edit (title, description and questions only).'),
        access.form_ids.length === 0
          ? E(Alert, {severity:'info', sx:{mb:1}}, 'Select view access to at least one form first.')
          : access.form_ids.map(function(formId) {
              var form = forms.filter(function(f){ return f.id === formId; })[0];
              if (!form) return null;
              var isEditable = (access.edit_form_ids || []).indexOf(formId) >= 0;
              return E(FormControlLabel, {key:'edit-'+formId, sx:{display:'block'},
                control:E(Checkbox, {size:'small', checked:isEditable,
                  onChange:function(){
                    var list = (access.edit_form_ids || []).slice();
                    if (isEditable) {
                      list = list.filter(function(f){ return f !== formId; });
                    } else {
                      list.push(formId);
                    }
                    setAccess(Object.assign({}, access, {edit_form_ids: list}));
                  }}),
                label:E(Typography, {variant:'body2'}, form.title)});
            }),

        E(Divider, {sx:{my:2}}),

        E(Typography, {variant:'subtitle2', sx:{mb:0.5}}, 'Questions'),
        E(Typography, {variant:'caption', color:'text.secondary', sx:{display:'block', mb:1.5}},
          'Leave every box unticked to share all questions on the forms above. Tick some to restrict to exactly those. This applies when they open an individual application; dashboards show only what the chart counts.'),

        access.form_ids.length === 0
          ? E(Alert, {severity:'info'}, 'Pick a form first.')
          : access.form_ids.map(function(formId) {
              var schema = schemas[formId];
              var form = forms.filter(function(f){ return f.id === formId; })[0];
              if (!schema) return E(Typography, {key:formId, variant:'body2', color:'text.secondary'},
                'Loading questions\u2026');
              var fields = (schema.fields || []).slice().sort(function(a,b){ return (a.order||0)-(b.order||0); });
              var sections = (schema.sections || []).slice().sort(function(a,b){ return (a.order||0)-(b.order||0); });
              return E(Box, {key:formId, sx:{mb:2}},
                E(Typography, {variant:'body2', fontWeight:700, sx:{mb:0.5}}, form ? form.title : ''),
                sections.length > 0
                  ? sections.map(function(sec) {
                      var secFields = fields.filter(function(f){ return f.section_id === sec.id; });
                      if (secFields.length === 0) return null;
                      return E(Box, {key:sec.id, sx:{pl:1, mb:1, borderLeft:'2px solid', borderColor:'divider'}},
                        E(Typography, {variant:'caption', color:'text.secondary', fontWeight:600}, sec.title),
                        secFields.map(function(f) {
                          return E(FormControlLabel, {key:f.id, sx:{display:'block', ml:0.5},
                            control:E(Checkbox, {size:'small',
                              checked:access.field_ids.indexOf(f.id) >= 0,
                              onChange:function(){ toggleField(f.id); }}),
                            label:E(Typography, {variant:'body2'}, f.label)});
                        }));
                    })
                  : fields.map(function(f) {
                      return E(FormControlLabel, {key:f.id, sx:{display:'block'},
                        control:E(Checkbox, {size:'small',
                          checked:access.field_ids.indexOf(f.id) >= 0,
                          onChange:function(){ toggleField(f.id); }}),
                        label:E(Typography, {variant:'body2'}, f.label)});
                    }));
            })),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setAccessFor(null); }}, 'Cancel'),
        E(Button, {variant:'contained', onClick:saveAccess}, 'Save access'))) : null,

    // Reset link, shown to the admin as well as emailed
    resetInfo ? E(Dialog, {open:true, onClose:function(){ setResetInfo(null); },
      maxWidth:'sm', fullWidth:true},
      E(DialogTitle, null, 'Reset link for ' + resetInfo.name),
      E(DialogContent, {dividers:true},
        E(Alert, {severity: resetInfo.emailed ? 'success' : 'warning', sx:{mb:2}},
          resetInfo.emailed
            ? 'Emailed to ' + resetInfo.email + '. Share the link below if it does not arrive.'
            : 'The email could not be sent \u2014 check SMTP settings. Share this link directly instead.'),
        E(TextField, {fullWidth:true, multiline:true, rows:2, value:resetInfo.link,
          label:'Reset link', InputProps:{readOnly:true},
          onFocus:function(e){ e.target.select(); }}),
        E(Typography, {variant:'caption', color:'text.secondary', sx:{display:'block', mt:1}},
          'Valid for 24 hours. Their current password keeps working until the link is used.')),
      E(DialogActions, null,
        E(Button, {onClick:function(){
          if (navigator.clipboard) navigator.clipboard.writeText(resetInfo.link);
          notify('Link copied', {variant:'info'});
        }}, 'Copy link'),
        E(Button, {variant:'contained', onClick:function(){ setResetInfo(null); }}, 'Done'))) : null);
}
